import React, { useRef, useState, useMemo } from "react";
import useTallestNodeValue from "../Common/Hooks/useTallestNodeHeight.jsx";
import { IconArrowSmall } from "../Common/index.js";
import NavPromo from "../NavPromo/NavPromo.jsx";

const SubNav = ({ subItems }) => {
  const subSub = useRef(null);
  //const tallestNodeValue = useTallestNodeValue(subSub, ".subnav--child > ul");
  const navHeight = ($(".primarynav--wrapper")?.height() - 20) || 150;
  const windowHeight = window.innerHeight - navHeight;
  const minHeight = Math.min(windowHeight, 425);

  // find default index once
  const defaultIndex = useMemo(() => {
    const idx = subItems.findIndex(item => item.isDefault);
    return idx === -1 ? 0 : idx;
  }, [subItems]);

  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const activeItem = subItems[activeIndex];

  const setActiveItem = function(index){
    const selectedItem = subItems[index];
    if (!selectedItem?.children || selectedItem?.children.length === 0) {
      setActiveIndex(defaultIndex)
    }else {
      setActiveIndex(index)
    }
  };

  return (
    <div className="subnav">
      <div className="subnav--wrapper" ref={subSub}>
        <div
          className="subnav--nav"
          style={{ maxHeight: windowHeight + "px", minHeight: minHeight }}
        >
          <ul className="subnav--parent">
            {subItems.map((items, index) => {
              const className = (index === activeIndex ? "active " : "") + (items.isDefault ? "default" : "")

              return (
                <li 
                  key={index} 
                  className={className}
                  onMouseEnter={() => setActiveItem(index)}
                  onFocus={() => setActiveItem(index)}
                >
                  <a href={items.url}>{items.name}</a>
                  <IconArrowSmall fill={"var(--midnight-blue)"} />
                </li>
              );
            })}
          </ul>
          <div className="subnav--child--container">
            {activeItem?.children && (
              <div className={activeItem?.children[0]?.promoData ? "subnav--child has-promo" : "subnav--child"}>
                <ul>
                  {activeItem.children.map(
                    (item) =>
                      item.name && (
                        <li key={item.id} className={item.icon ? "indent" : ""}>
                          <div>
                            {item.icon && (
                              <span className="icon">
                                <img src={item.icon} alt={item.alt} />
                              </span>
                            )}
                            <a href={item.url}>{item.name}</a>
                            {item.arrow && (
                              <IconArrowSmall
                                fill={"var(--midnight-blue)"}
                              />
                            )}
                          </div>  
                          <p>{item.text}</p>
                        </li>
                      )
                  )}
                  {activeItem?.children[0]?.promoData && (
                    <li className="subnav--promo-desktop">
                      <NavPromo data={activeItem.children[0].promoData} />
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubNav;
